<template>
  <div class="deposit">
    <div style="text-align: center;">
      <div class="col-7" style="background-color: #fff;border-radius:1rem;margin: 0 auto;padding-left: 2%;">
        <div style="padding-top: 2rem;">
        </div>
        <div style="height: 2.5rem;">
          <label :style="{float: 'left',fontSize : 1*windowWidth/100+'px'}" class="tips_front"><strong>账号登录</strong></label>
        </div>
        <div class="row">
          <div class="col-6">
            <input :style="{float: 'left',fontSize : 1*windowWidth/100+'px'}" type="text" class="form-control" id="username" placeholder="请输入账号"/>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-primary" :style="{float: 'left',color: 'aliceblue',fontSize : 1*windowWidth/100+'px'}">确认账号</button>
          </div>
        </div>
        <div style="padding-top: 3rem;"></div>
        <div style="height: 2.5rem;">
          <label :style="{float: 'left',fontSize : 1*windowWidth/100+'px'}" class="tips_front"><strong>充值金额</strong></label>
        </div>
        <div class="row">
          <div class="col-4">
            <input type="radio" class="btn-check" id="money-50" autocomplete="off" name="selectMoney">
            <label class="btn border" for="money-50" :style="{  color: money===19 ? '#2383f1' : '#000' , borderColor : money===19 ? '#2383f1 !important' : '#999999 !important' , width: '100%' ,fontSize : 1*windowWidth/100+'px'}" @click="moneySelect(19)"><strong>190  金币</strong><br/><p class="moneyFont">¥19</p></label>
            <div class="radio-btn-cheaked" :style="{ visibility: money===19 ? 'visible' : 'hidden'}"></div>
          </div>
          <div class="col-4">
            <input type="radio" class="btn-check" id="money-100" autocomplete="off" name="selectMoney">
            <label class="btn border radio-btn" for="money-100" :style="{ color: money===49 ? '#2383f1' : '#000' , borderColor : money===49 ? '#2383f1 !important' : '#999999 !important' , width: '100%',fontSize : 1*windowWidth/100+'px' }" @click="moneySelect(49)"><strong>490  金币</strong><br/><p class="moneyFont">¥49</p></label>
            <div class="radio-btn-cheaked" :style="{ visibility: money===49 ? 'visible' : 'hidden' }"></div>
          </div>
        </div>
        <div style="padding-top: 3rem;"></div>
        <div style="height: 2.5rem;">
          <label :style="{float: 'left',fontSize : 1*windowWidth/100+'px'}" class="tips_front"><strong>支付方式</strong></label>
        </div>
        <div class="row">
          <div class="col-4">
            <input type="radio" class="btn-check" id="wechat" autocomplete="off" name="selectPayWay">
            <label class="btn border" for="wechat" :style="{ color: payWay==='wechat' ? '#2383f1' : '#000', width: '100%',borderColor : payWay==='wechat' ? '#2383f1 !important' : '#999999 !important',paddingTop: '1.2rem',fontSize : 1*windowWidth/100+'px' }" @click="payWaySelect('wechat')"><img class="wechatimg rounded"/>   <strong>微信支付</strong></label>
            <div class="radio-btn-cheaked" :style="{ visibility: payWay==='wechat' ? 'visible' : 'hidden' }"></div>
          </div>
          <div class="col-4">
            <input type="radio" class="btn-check" id="alipay" autocomplete="off" name="selectPayWay">
            <label class="btn border radio-btn" for="alipay" :style="{ color: payWay==='alipay' ? '#2383f1' : '#000', width: '100%',borderColor : payWay==='alipay' ? '#2383f1 !important' : '#999999 !important',paddingTop: '1.2rem',fontSize : 1*windowWidth/100+'px' }" @click="payWaySelect('alipay')"><img class="alipayimg rounded"/>   <strong>支付宝支付</strong></label>
            <div class="radio-btn-cheaked" :style="{ visibility: payWay==='alipay' ? 'visible' : 'hidden' }"></div>
          </div>
        </div>
        <div style="padding-top: 5rem;"></div>
        <div>
          <button type="button" class="btn btn-primary btn-lg" :style="{width: '50%',fontSize : 1*windowWidth/100+'px'}">立即充值</button>
        </div>
        <div style="padding-top: 3rem;"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Deposit',
  data () {
    return {
      data: [],
      money: 0,
      payWay: '',
      windowWidth: 1920
    }
  },
  methods: {
    loadimg: function () {
      this.$http.get('http://74.120.171.191:8086/picture/pixiv').then((response) => {
        console.log(response)
        if (response.data.code === 200) {
          console.log('run----------------------------------------------')
          let index = 0
          let count = 3
          let arrTemp = []
          let experts = response.data.data.list
          for (let i = 0; i < experts.length; i++) {
            index = parseInt(i / count)
            if (arrTemp.length <= index) {
              arrTemp.push([])
            }
            arrTemp[index].push(experts[i])
          }
          this.data = arrTemp
          console.log(this.data)
        }
      })
    },
    moneySelect: function (money) {
      this.money = money
    },
    payWaySelect: function (payWay) {
      this.payWay = payWay
    }
  },
  mounted () {
    this.windowWidth = document.body.clientWidth
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #2383f1;
}

.tips_front {
  font-size: 1.3rem;
}

.radio-btn-cheaked{
  border-color:#2383f1 !important;
  width: 1rem;
  height: 1rem;
  background-image: url('../../static/img/icon_select.png');
  background-size: 100% 100%;
  margin-top: -1rem;
  float: right;
  position: relative;
}

.wechatimg{
  width: 1.3rem;
  height: 1.3rem;
  background-image: url('../../static/img/icon_wechat.png');
  background-size: 100% 100%;
  max-width: 50%;
  max-height: 50%;
}

.alipayimg{
  width: 1.3rem;
  height: 1.3rem;
  background-image: url('../../static/img/icon_alipay.png');
  background-size: 100% 100%;
  max-width: 50%;
  max-height: 50%;
}

.moneyFont{
  color: #999;
  font-size: 0.8rem;
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Deposit.vue